import React from 'react'
import { CustomerAddress } from 'lib/types/core'
import { ShippingData } from '../../../../../../../../components/ShippingData'

interface Props {
  address: CustomerAddress
}

export const AddressInfo: React.FC<Props> = ({ address }) => (
  <div className='address'>
    <ShippingData address={address} />
  </div>
)
